module.exports = __webpack_public_path__ + "img/team_2.17ceaef0.png";